import { TCatalogTier } from './catalog-layout';

/** `menu_v2` event labels of the Menú page (plan §5.19). */
export type TMenuV2EventLabel =
  | `open:${TCatalogTier}`
  | 'quick_price'
  | 'toggle'
  | 'photo_tile'
  | 'quick_add'
  | 'duplicate'
  | 'move'
  | 'bulk_hide'
  | 'bulk_show'
  | 'bulk_move'
  | 'bulk_delete'
  | 'bulk_price'
  | 'reorder'
  | 'category_delete:move'
  | 'category_delete:delete'
  | 'discounts_switch'
  | 'popular_switch'
  | 'popular_item'
  | 'popular_category';

export const MENU_V2_EVENT = 'menu_v2';

export function menuV2EventParams(
  label: TMenuV2EventLabel
): {
  event_category: 'catalog';
  event_label: TMenuV2EventLabel;
} {
  return { event_category: 'catalog', event_label: label };
}

/** The ads conversion fires when the store reaches this many products (legacy parity). */
export const CONVERSION_PRODUCT_COUNT = 5;
